import { ActionTypes } from '../constants/index';

export const getSupport = (payload: any) => ({
  type: ActionTypes.SUPPORT_MGMT_LIST_REQUEST,
  payload,
});
